module.exports = __webpack_public_path__ + "static/media/9.Foam Gun.7c1b663e.jpg";